import * as React from "react";

export default class bottomFotter extends React.Component<any, any> {
  public render() {
    return (
      <footer className="footer-bottom">
        <div className="container">
          <p>Made by Itamar Davidyan.</p>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/BottomFooter.tsx